import React from 'react';
import WorkflowContainer from '../../containers/manufacturingmng/workflow/WorkflowContainer';

const ProcessTemplatePage = () => {
  return <WorkflowContainer pageUrl="/processtemplate" />;
};

export default ProcessTemplatePage;
